import styles from "./Footer.module.css";

export default function Footer() {
    return (
        <footer className={styles.footer}>
            <nav className={styles.footerNav}>
                <a href="https://www.studierendenwerk-siegen.de/kontakt/" className={styles.footerLink}>Kontakt</a>
                <a href="https://www.studierendenwerk-siegen.de/datenschutzerklaerung/" className={styles.footerLink}>Datenschutz</a>
                <a href="https://www.studierendenwerk-siegen.de/impressum/" className={styles.footerLink}>Impressum</a>
            </nav>
            <small className={styles.credits}>
                Entwickelt von&nbsp;
                <a href="https://yazan-al-kabbani.de/" target="_blank" rel="noopener noreferrer" className={styles.creditLink}>
                    Yazan Al-Kabbani
                </a>
            </small>
        </footer>
    );
}
